import { lazy } from 'react';
import RouteGuard from '../routerPermission';

const LogisticsSettingsPage = lazy(() => import('@/widgets/merchant-logistics/LogisticsSettingsPage'));
const PickupsPage = lazy(() => import('@/widgets/merchant-logistics/PickupsPage'));
const ShipmentsPage = lazy(() => import('@/widgets/merchant-logistics/ShipmentsPage'));
const TicketsPage = lazy(() => import('@/widgets/merchant-logistics/TicketsPage'));
const CodRequestsPage = lazy(() => import('@/widgets/merchant-logistics/CodRequestsPage'));
const SettlementsPage = lazy(() => import('@/widgets/merchant-logistics/SettlementsPage'));
const InvoicesPage = lazy(() => import('@/widgets/merchant-logistics/InvoicesPage'));

const MerchantLogisticsRoutes = {
  // URL is `upaya-logistics/*` (not just `logistics/*`) because right now
  // Upaya is the only provider wired in — the previous generic label was
  // misleading. Rename if a second provider is ever added.
  path: 'upaya-logistics',
  children: [
    {
      path: 'settings',
      element: (
        <RouteGuard resource="store" action="read">
          <LogisticsSettingsPage />
        </RouteGuard>
      ),
    },
    {
      path: 'pickups',
      element: (
        <RouteGuard resource="order" action="read">
          <PickupsPage />
        </RouteGuard>
      ),
    },
    {
      path: 'shipments',
      element: (
        <RouteGuard resource="order" action="read">
          <ShipmentsPage />
        </RouteGuard>
      ),
    },
    {
      path: 'tickets',
      element: (
        <RouteGuard resource="order" action="read">
          <TicketsPage />
        </RouteGuard>
      ),
    },
    {
      path: 'tickets/:ticketId',
      element: (
        <RouteGuard resource="order" action="read">
          <TicketsPage />
        </RouteGuard>
      ),
    },
    {
      path: 'cod-requests',
      element: (
        <RouteGuard resource="order" action="read">
          <CodRequestsPage />
        </RouteGuard>
      ),
    },
    {
      path: 'settlements',
      element: (
        <RouteGuard resource="order" action="read">
          <SettlementsPage />
        </RouteGuard>
      ),
    },
    {
      path: 'invoices',
      element: (
        <RouteGuard resource="order" action="read">
          <InvoicesPage />
        </RouteGuard>
      ),
    },
  ],
};

export default MerchantLogisticsRoutes;
